import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-7_yongzhang_no",
  "use": "icon-7_yongzhang_no-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol viewBox=\"0 0 40 40\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-7_yongzhang_no\">\n<path d=\"M10 30.5C10 29.6716 10.6716 29 11.5 29H28.5C29.3284 29 30 29.6716 30 30.5V30.5C30 31.3284 29.3284 32 28.5 32H11.5C10.6716 32 10 31.3284 10 30.5V30.5Z\" fill=\"#BBD0EA\" />\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.4964 20.9784C22.4034 20.4207 22.7131 19.8828 23.1916 19.5817C24.8788 18.5197 26 16.6408 26 14.5C26 11.1863 23.3137 8.5 20 8.5C16.6863 8.5 14 11.1863 14 14.5C14 16.6408 15.1212 18.5197 16.8084 19.5817C17.2869 19.8828 17.5966 20.4207 17.5036 20.9784V20.9784C17.4053 21.5679 16.8953 22 16.2976 22H11C9.89543 22 9 22.8954 9 24V25.5C9 26.6046 9.89543 27.5 11 27.5H29C30.1046 27.5 31 26.6046 31 25.5V24C31 22.8954 30.1046 22 29 22H23.7024C23.1047 22 22.5947 21.5679 22.4964 20.9784V20.9784Z\" fill=\"#BBD0EA\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/7_yongzhang_no.svg
// module id = WNHC
// module chunks = 45